import {useFlashMessagesStore} from '@/store/flash-messages.store.js'
import {storeToRefs} from 'pinia'

/**
 * Flash messages composable (convenience wrapper around the store)
 */
export function useFlashMessages() {

  //Get refs and methods from store
  const store = useFlashMessagesStore()
  const {flashMessages} = storeToRefs(store)
  const {
    showFlashMessage,
    hideFlashMessage,
    setFlashSuccess,
    setFlashFailure,
    createFlashMessage,
  } = store

  //Expose reactive interface
  return {
    flashMessages,
    showFlashMessage,
    hideFlashMessage,
    setFlashSuccess,
    setFlashFailure,
    createFlashMessage,
  }
}
